import React, { useState } from 'react';
import { Modal, Button, Form, Alert, Card } from 'react-bootstrap';
import { twoFactorAPI } from '../api/twoFactorAPI';

function TwoFactorVerification({ show, username, onSuccess, onCancel }) {
    const [token, setToken] = useState('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (token.length !== 6) {
            setError('Please enter a 6-digit code');
            return;
        }
        
        setLoading(true);
        setError(null);

        try {
            const response = await twoFactorAPI.verifyLogin(username, token);
            if (response && response.success) {
                onSuccess();
            }
        } catch (error) {
            setError('Invalid verification code. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setToken('');
        setError(null);
        onCancel();
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    <i className="fas fa-shield-alt me-2"></i>
                    Two-Factor Authentication
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Card className="mb-3">
                    <Card.Body className="text-center">
                        <i className="fas fa-mobile-alt fa-3x text-primary mb-3"></i>
                        <h5>Enter Verification Code</h5>
                        <p className="text-muted mb-0">
                            Please enter the 6-digit code from your authenticator app for <strong>{username}</strong>
                        </p>
                    </Card.Body>
                </Card>
                
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label>Verification Code</Form.Label>
                        <Form.Control
                            type="text"
                            value={token}
                            onChange={(e) => {
                                const value = e.target.value.replace(/\D/g, '').slice(0, 6);
                                setToken(value);
                                setError(null);
                            }}
                            placeholder="Enter 6-digit code"
                            maxLength="6"
                            className="text-center"
                            style={{ fontSize: '1.5rem', letterSpacing: '0.5rem' }}
                            autoFocus // eslint-disable-line jsx-a11y/no-autofocus
                            autoComplete="off"
                            spellCheck="false"
                        />
                    </Form.Group>
                    
                    {error && <Alert variant="danger">{error}</Alert>}
                    
                    <div className="d-flex justify-content-between">
                        <Button 
                            variant="secondary" 
                            onClick={handleClose}
                            disabled={loading}
                        >
                            Cancel
                        </Button>
                        <Button 
                            type="submit" 
                            variant="primary"
                            disabled={token.length !== 6 || loading}
                        >
                            {loading ? 'Verifying...' : 'Verify'}
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
}

export default TwoFactorVerification;
